import React from "react";
import { View, StyleSheet, Image } from "react-native";
import config from "../config/config";
import AppText from "./AppText";

function ActivityIndicator({ visible = false }) {
    if (!visible) return null;

    return (
        <View style={styles.overlay}>
            <Image source={config.media.logo} resizeMode={"contain"} />
            <AppText style={config.boldText}>LOADING</AppText>
        </View>
    );
}

const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        alignItems: "center",
        backgroundColor: config.colors.tertiary,
        justifyContent: "center",
    },
});

export default ActivityIndicator;
